<template>
  <b-navbar toggleable="lg" type="dark" variant="info">
    <b-navbar-brand href="#">
      <img src="@/assets/img/sabespPhotoshop.png" width="30px">
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav v-for="route in routes" :key="route.rota">
        <b-nav-item :to="route.rota">{{ route.nome }}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right v-b-tooltip.bottom
          title="Clique aqui para gerenciar sua conta ou fazer logoff do sistema">
          <template v-slot:button-content>
            <b-avatar class="mr-3">{{ name.substring(0, 2).toUpperCase() }}</b-avatar>
            <span class="mr-auto text-dark">{{ name }}</span>
            <span class="mr-auto text-dark"> | {{ descProfile.replace('"', '').replace('"', '') }} </span>
          </template>
          <b-dropdown-item right to="/conta">Conta</b-dropdown-item>
          <b-dropdown-item right @click="sair">Sair</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'NavBar',
  data () {
    return {
      descProfile: localStorage.getItem('descPerfil'),
      name: localStorage.getItem('nome'),
      routes: JSON.parse(localStorage.getItem('rotas'))
    }
  },
  methods: {
    ...mapActions('Global', ['logout']),
    sair () {
      this.logout()
        .then(() => this.$router.push('/login'))
    }
  }
}
</script>
